import React from "react";
import { portalApps, resolveAppUrl } from "../config/appScope";
import "./Portal.css";

const authApp = { localUrl: "http://localhost:3001", url: "https://auth.grow-emphatic.com" };

const Portal = () => {
  return (
    <div className="portal-page">
      <header className="portal-header">
        <h1>grow-emphatic.com</h1>
        <p>Choose an app or sign in once for all services.</p>
        <a className="portal-auth-link" href={`${resolveAppUrl(authApp)}/login`}>Sign in</a>
      </header>
      <div className="portal-grid">
        {portalApps.map((app) => (
          <a key={app.id} className="portal-card" href={resolveAppUrl(app)}>
            <h3>{app.title}</h3>
            <p>{app.description}</p>
          </a>
        ))}
      </div>
    </div>
  );
};

export default Portal;
